import { Market, Region } from 'clickNgo/configs/geo'
import { Nullable } from 'cng-common/models/utils'
import { IGeoMappingItem } from 'partner360/components/filters'
import { IReportProducts } from 'partner360/features/reports/model/types'
import { IActualsSyncInfo } from 'partner360/models/report/iActualsSyncInfo'
import { IReportPartner as IReportPartnerV1 } from 'partner360/models/report/IReportPartner'
import { IReportPeriod } from 'partner360/models/report/iReportPeriod'
import { IReportPredefineFilters } from 'partner360/models/report/IReportPredefineFilters'
import { IReportsPartnerTypes } from 'partner360/models/report/IReportsPartnerTypes'

import { TProductHierarchy } from './product'

export interface IReportPartner {
  DatasetId: 3
  PartnerId: string
  PartnerRanks: string
  PartnerName: string
  PartnerSpecialization: string
  GeoRegion: Region
  GeoMarket: Market
  GeoMarketOrder: number
  Country: string
  CountryCode: string
  GlobalPartnerId: Nullable<string>
  GlobalPartnerName: Nullable<string>
  LocationId: string
  IsGlobal: 0 | 1
  AmplifyMembership: Nullable<string>
}

export interface IDashboardReportsData<T> {
  ProductHierarchy: TProductHierarchy[]
  Partners: IReportPartner[]
  Organizations: string[]
  Data: T[]
  PredefinedFilters: IReportPredefineFilters[]
  ActualsSyncInfo: IActualsSyncInfo[]
  GeoMapping: IGeoMappingItem[]
}

export interface IChartInfo<T> {
  label: T
  color: string
}

export type TCompletenessStatusConfig<T extends string> = Record<
  number,
  { color: string; label: T; tooltip?: string }
>

export interface IDefaultView {
  ViewId: 'PartnerView' | 'QuarterlyView' | 'TrendView'
  ViewPeriodTitle?: string
}

export interface IAnalyticsReportData<AnalyticsReportInfo> {
  ReportsEntryId: number
  DefaultView?: IDefaultView[]
  Data: AnalyticsReportInfo[]
  GeoMapping: IGeoMappingItem[]
  ActualsSyncInfo: IActualsSyncInfo[]
  PartnerFlags: {
    Icon: string //'normal-icon'
    IsTopMarket: number // 1 | 0
    IsTopWW: number // 1 | 0
    Offering: string
    PartnerFlag: string
    RTM: string
    SortOrder: number
    Title: string
    Type: string
  }[]
  PartnerTypes: IReportsPartnerTypes[]
  Partners: IReportPartnerV1[]
  Organizations: string[]
  ProductHierarchy: IReportProducts[]
  PredefinedFilters: IReportPredefineFilters[]
  ListOfPeriods: IReportPeriod[]
}
export enum AcknowledgedStatus {
  All = -1,
  Acknowledged = 1,
  Unacknowledged = 2,
}
